import { EventEmitter, Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
//import { PDFDocument } from 'pdf-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { RapportDto } from '../../data-management';

@Injectable({
  providedIn: 'root',
})
export class NewImportExportService {
  private pdfSrc: BehaviorSubject<SafeResourceUrl | null> =
    new BehaviorSubject<SafeResourceUrl | null>(null);
  private pdf: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private excelData: BehaviorSubject<unknown[] | any[][] | null> =
    new BehaviorSubject<unknown[] | any[][] | null>(null);
  private downloadLink: BehaviorSubject<SafeResourceUrl | null> =
    new BehaviorSubject<SafeResourceUrl | null>(null);
  private curentRapport: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(    localStorage.getItem("current_report")||null);
  private showPdf: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private refreshTrigger: BehaviorSubject<void> = new BehaviorSubject<void>(
    undefined
  ); // ou new BehaviorSubject<void>()
private stopDaily: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    JSON.parse(localStorage.getItem('dailyPOI')) || false
  );
private noStopDaily: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    JSON.parse(localStorage.getItem('dailyNOPOI')) || false
  );
private byVehicule: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  public showPdfEmitter = new EventEmitter<void>();

  private sendingReport : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  )

  private rapportDto : BehaviorSubject<RapportDto> = new BehaviorSubject<RapportDto>(
    new RapportDto()
  )

  private rapportsSend : BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    []
  )

  private rapportsLoaded = false;


  constructor(private sanitizer: DomSanitizer) {}

  isPdfObs(): Observable<boolean> {
    return this.pdf.asObservable();
  }
  isPdf(): boolean {
    return this.pdf.value;
  }

  isRapportsLoaded(): boolean {
  return this.rapportsLoaded;
}

  setRapportSend(rapports:any[]){
    this.rapportsSend.next(rapports)
      this.rapportsLoaded = true; // on marque que le chargement complet a été fait

  }

  getRapportsSend(): Observable<any[]>{
    return this.rapportsSend.asObservable()
  }

  getRapportsSendValue(): any[]{
    return this.rapportsSend.value
  }

  addRapport(rapport: any): void {
  const rapports = this.rapportsSend.getValue();

  this.rapportsSend.next([
    ...rapports,
    rapport
  ]);
}


// UPDATE
updateRapport(rapportUpdated: any): void {
  const rapports = this.rapportsSend.getValue();

  const updatedRapports = rapports.map(rapport =>
    rapport.id === rapportUpdated.id
      ? rapportUpdated
      : rapport
  );

  this.rapportsSend.next(updatedRapports);
}


// DELETE
deleteRapport(id: any): void {
  const rapports = this.rapportsSend.getValue();

  const filteredRapports = rapports.filter(
    rapport => rapport.id !== id
  );

  this.rapportsSend.next(filteredRapports);
}



  setPdfExistince(isExist: boolean): void {
    this.pdf.next(isExist);
  }

  isDailyStop(){
    return this.stopDaily.asObservable()
  }

  setDailyStop(v:boolean){
    this.stopDaily.next(v)
    localStorage.setItem('dailyPOI',JSON.stringify(this.stopDaily.value))
  }

    isSending(){
      return this.sendingReport.asObservable()
    }

    getRapportDto(){
      return this.rapportDto.asObservable()
    }

    setRapportDto(rapport:RapportDto){
      this.rapportDto.next(rapport)
    }

    setSendingReport(s:boolean){
      this.sendingReport.next(s)
    }

  isDailyNOStop(){
    return this.noStopDaily.asObservable()
  }

  setByVehicule(v:boolean){
    this.byVehicule.next(v)
  }

  isByVehicule(){
    return this.byVehicule.asObservable()
  }

  setDailyNOStop(v:boolean){
    this.noStopDaily.next(v)
    localStorage.setItem('dailyNOPOI',JSON.stringify(this.noStopDaily.value))
  }

  getCurentRapport(): string | null {
    return this.curentRapport.value;
  }
  getRapport(): Observable<string | null> {
    return this.curentRapport.asObservable();
  }
  setCurentRapport(rapport: string | null): void {
    this.curentRapport.next(rapport);
    localStorage.setItem("current_report",rapport)
  }

  getPdfToBePrinted(): Observable<SafeResourceUrl | null> {
    return this.pdfSrc;
  }
  getDonloadPrinted(): Observable<SafeResourceUrl | null> {
    return this.downloadLink;
  }
  setPdfToBePrinted(blob: Blob | null): void {
    if (blob) {
      //  this.loadAndModifyPdf(blob);
    } else {
      this.pdfSrc.next(null);
      this.downloadLink.next(null);
    }
  }

  getShowPdf(): Observable<boolean> {
    return this.showPdf;
  }
  setShowPdf(show: boolean): void {
    this.showPdf.next(show);
  }

  // private async loadAndModifyPdf(pdfBlob: Blob): Promise<void> {
  //   this.blobToUint8Array(pdfBlob).then(async (pdfData) => {
  //     const pdfDoc = await PDFDocument.load(pdfData);
  //     const pdfBytes = await pdfDoc.save();
  //     const updatedBlob = new Blob([pdfBytes], { type: 'application/pdf' });
  //     const downloadURL = URL.createObjectURL(updatedBlob);
  //     this.pdfSrc.next(
  //       this.sanitizer.bypassSecurityTrustResourceUrl(
  //         downloadURL + '#view=FitV' + '&toolbar=1' + '&nameddest=test'
  //       )
  //     );
  //     this.downloadLink.next(
  //       this.sanitizer.bypassSecurityTrustResourceUrl(downloadURL)
  //     );
  //   });
  // }

  getExcelData(): Observable<unknown[] | any[][] | null> {
    return this.excelData.asObservable();
  }
  setExcelData(data: unknown[] | null | any[][]): void {
    this.excelData.next(data);
  }

  setExcelToBeProcessed(blob: Blob | null): void {
    if (blob) {
      this.loadAndModifyExcel(blob);
    } else {
      this.excelData.next(null);
      this.downloadLink.next(null);
    }
  }

  private async loadAndModifyExcel(excelBlob: Blob): Promise<void> {
    this.blobToUint8Array(excelBlob).then((excelData) => {
      // Lire le fichier Excel
      const workbook = XLSX.read(excelData, { type: 'array' });

      // Vérifier si le fichier contient une ou plusieurs feuilles
      if (workbook.SheetNames.length === 1) {
        // Cas où il y a une seule feuille
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        this.excelData.next(jsonData);

        // Créer un nouveau Blob Excel à partir des données
        const newExcelBlob = this.createExcelBlob(workbook);
        const downloadURL = URL.createObjectURL(newExcelBlob);

        // Mettre à jour les liens pour le téléchargement
        this.pdfSrc.next(
          this.sanitizer.bypassSecurityTrustResourceUrl(downloadURL)
        );
        this.downloadLink.next(
          this.sanitizer.bypassSecurityTrustResourceUrl(downloadURL)
        );
      } else {
        // Cas où il y a plusieurs feuilles
        const allSheetData: any[] = [];

        // Parcours de chaque feuille dans le classeur
        workbook.SheetNames.forEach((sheetName) => {
          const worksheet = workbook.Sheets[sheetName];
          console.log(`--- Feuille: ${sheetName} ---`);
  console.log('Cellule F6 (Temps arrêt):', worksheet['F6']);
  console.log('Cellule G6 (Dépassement):', worksheet['G6']);
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // Ajouter les données de la feuille dans allSheetData
          allSheetData.push({
            sheetName: sheetName,
            data: jsonData,
          });
        });

        // Mettre à jour excelData avec les données de toutes les feuilles
        this.excelData.next(allSheetData);

        // Créer un nouveau Blob Excel à partir des données
        const newExcelBlob = this.createExcelBlob(workbook);
        const downloadURL = URL.createObjectURL(newExcelBlob);

        // Mettre à jour les liens pour le téléchargement
        this.pdfSrc.next(
          this.sanitizer.bypassSecurityTrustResourceUrl(downloadURL)
        );
        this.downloadLink.next(
          this.sanitizer.bypassSecurityTrustResourceUrl(downloadURL)
        );
      }
    });
  }

  private createExcelBlob(workbook: XLSX.WorkBook): Blob {
    const workbookOut = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    return new Blob([workbookOut], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
  }

  private blobToUint8Array(blob: Blob): Promise<Uint8Array> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () =>
        resolve(new Uint8Array(reader.result as ArrayBuffer));
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  }

  getRefreshTrigger(): Observable<void> {
    return this.refreshTrigger.asObservable();
  }

  forceEmitRefresh(): void {
    this.refreshTrigger.next(); // Réémet le signal
  }
}
